import { List, ListItem } from '@mui/material';

import { CalendarMeetingDto } from '@/api/generated';
import {
  MeetingTasks,
  SubTitle,
  TaskTitle,
  UserTasks,
  UserTitle
} from '@/components/Meeting/components/MeetingOverview/MeetingOverviewStyles';

const MeetingOverviewTasks = ({
  meeting,
  includeTitle
}: {
  meeting?: CalendarMeetingDto;
  includeTitle?: boolean;
}) => (
  <MeetingTasks>
    {includeTitle && <SubTitle>Tasks</SubTitle>}
    {meeting?.tasks?.participantsTasks?.map((userTask, index) => (
      <UserTasks key={index}>
        <UserTitle>{userTask.name}</UserTitle>
        <List sx={{ listStyleType: 'disc', pl: 2 }}>
          {userTask?.tasks?.map((task, index) => (
            <ListItem key={index} disablePadding sx={{ display: 'list-item' }}>
              <TaskTitle>{task} </TaskTitle>
            </ListItem>
          ))}
        </List>
      </UserTasks>
    ))}
  </MeetingTasks>
);

export default MeetingOverviewTasks;
